import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';

import Tooltip from '@mui/material/Tooltip';
import { COLORS, useLiveCursors } from './useLiveCursors';
import { USERS } from '../../../providers/users';
import { getInitials } from '../../../utils';
import { toggleCursorConnections, useCursorConnections } from '../LiveBlockNotification/notification-store';

export const LiveAvatar = () => {
  const others = useLiveCursors();

  const cursorsToDisplay = useCursorConnections();

  return (
    <AvatarGroup spacing="medium">
      {others.map((user) => {
        const userObj = USERS.find((u) => u.id === user.id);

        if (!userObj) return null;

        const cursoIsLive = cursorsToDisplay.includes(user.connectionId);

        return (
          <Tooltip title={userObj.name || userObj.id} key={userObj?.id}>
            <Avatar
              alt={userObj?.id}
              src={userObj.avatar}
              onClick={() => toggleCursorConnections(user.connectionId)}
              component="div"
              sx={{
                border: `2px solid ${cursoIsLive ? COLORS[user.connectionId % COLORS.length] : '#fff'} !important`,
                width: '28px !important',
                height: '28px !important',
                '& img': {
                  transform: 'translateY(1px)',
                },
                cursor: 'pointer',
              }}
            >
              {getInitials(userObj.name || userObj.id)}
            </Avatar>
          </Tooltip>
        );
      })}
    </AvatarGroup>
  );
};
